export default __webpack_public_path__ + "static/media/serene-heights-plan-legends.6ab7c2c1.png";